import React, { useEffect, useState } from "react";
import striptags from "striptags";
import Head from "next/head";
import Link from "next/link";
import { useSelector } from "react-redux";
import Image from "next/image";
import dynamic from "next/dynamic";

const Layout = dynamic(() => import("../components/common/Layout/Layout"));
const Loader = dynamic(() => import("../components/common/Loader/Loader"));

const ThankYou = ({ apiData }) => {
  const [thankData, setThankData] = useState();
  const [loader, setLoader] = useState(true);

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    const data = apiData?.detail_page;
    data && setThankData(data);
    if (footerData) {
      setLoader(false);
    }
  }, []);

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <main className="main-wrapper thankyou-page-middle wrapper-top-bg">
          <article className="wrapper-inner">
            <section className="error-content-section thank-you-section">
              <div className="container">
                {thankData?.map((val, i) => {
                  const titleWithoutPTag = striptags(
                    val?.value?.title,
                    "<span>"
                  );
                  if (val?.type == "thank_you_content") {
                    return (
                      <div className="row error-content-row" key={i}>

                        <div className="col-md-6">
                          <div className="error-page-title title-error-500">
                            <h1
                              dangerouslySetInnerHTML={{
                                __html: titleWithoutPTag,
                              }}
                            ></h1>
                          </div>
                          <div className="error-content mb-20">
                            <p className="thankyou-description">{striptags(val?.value?.msg)}</p>
                          </div>
                          <div className="back-home-btn">
                            <Link className="btn btn-primary" href="/">
                              {striptags(val?.value?.page?.title)}
                            </Link>
                            <div className="error-page-msg"></div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="error-page-img">
                            <Image
                              height={100}
                              width={100}
                              src={val?.value?.image?.url}
                              alt={val?.value?.image?.alt_text ?? 'Thank you'}
                              className="error-img-500"
                              loading="eager"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </section>
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/thanks/",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  return {
    props: {
      apiData,
    },
  };
}

export default ThankYou;
